import { SAVE_XEROX_CODE, SAVE_XEROX_CODE_FAIL, SAVE_XEROX_CODE_SUCCESS } from "./actionType";

export const saveXeroxCode = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SAVE_XEROX_CODE,
  payload: { data, onSuccess, onError },
});

export const saveXeroxCodeSuccess = (data = {}) => ({
  type: SAVE_XEROX_CODE_SUCCESS,
  payload: data,
});

export const saveXeroxCodeFail = (data = {}) => ({
  type: SAVE_XEROX_CODE_FAIL,
  payload: data,
});
